<template>
  <div class="div-componenteInformacionSinRegistros">
    <!-- No existen registros de volcado -->
    <div class="div-sinRegistrosBuscados">
      <f7-row>
        <f7-col class="col-iconoListaVacia">
          <img
            src="@/static/icons/ic_search-2.svg"
            alt="iconSearch"
            width="126"
            height="111"
          >
        </f7-col>
      </f7-row>
      <f7-row>
        <f7-col class="col-textoListaVacia">
          <span
            class="span-informacionSinRegistrosBuscados"
            data-testid="uc-information-without-search-record-text"
          >
            {{ t('informationWithoutSearchRecord.text') }}
          </span>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script setup>
// @ts-check
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped>
.div-sinRegistrosBuscados {
  background: var(--his-tierra-white);
  min-height: -webkit-fill-available;
}

.span-informacionSinRegistrosBuscados {
  color: var(--his-ash-gray);
  font-size: 16px;
}

.col-iconoListaVacia {
  display: flex;
  justify-content: center;
  padding-top: 90px;
}

.col-textoListaVacia {
  text-align: center;
  padding-top: 13px;
}
</style>
